<mat-icon class="bk-info-icon material-symbols-outlined"
    matTooltip="{{title | translate}}"
    [matTooltipClass]="'cm-verbose-tooltip'"
    [matTooltipPosition]="'above'" >help_outline</mat-icon>